import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/products'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataListLow: [],
    dataItem: {
      id: null,
      title: null,
      summary: null,
      content: null,
      content_albert_genau: null,
      content_ferrini: null,
      video_embed: null,
      ordering: null,
      slug: null,
      year: null,
      id_product_categories: null,
      districts: null,
      status: null,
      is_home: null,
      features: [],
      featureList: [],
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    listFilters: {
      searchText: '',
      filterCategory: null,
      currentPage: 1,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },

    dataListLow(state) {
      return state.dataListLow
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    listFilters(state) {
      return state.listFilters
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_LIST_FILTERS(state, data) {
      state.listFilters = {
        ...state.listFilters,
        ...data,
      }
    },
    SET_DATA_LIST_LOW(state, data) {
      state.dataListLow = data
    },
    SET_VIDEO_EMBED_SAVE(state, data) {
      state.dataSaveEmbed = data
    },
    RESET_DATA_ITEM(state, data) {
      if (data) {
        state.dataItem = {
          id: null,
          title: null,
          summary: null,
          content: null,
          content_albert_genau: null,
          video_embed: null,
          ordering: null,
          slug: null,
          districts: null,
          id_product_categories: null,
          features: [],
          featureList: [],
          status: null,
          year: null,
          is_home: null,
        }
      }
    },

  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    getDataList2({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            commit('SET_DATA_LIST_LOW', response.data.data)
            commit('SET_DATA_COUNTS', response.data.count)
          })
          .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'products.id': id,
        },
        array: false,
        isAdmin: true,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    resetDataItem({ commit }) {
      commit('RESET_DATA_ITEM', true)
    },
    saveImage({ commit }, data) {
      axiosIns
        .post(`${ROOT_URL}/saveImage`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeImageData({ commit }, postData) {
      // const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/deleteImage`, { postData })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    reOrderingImages({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/reOrderingImages`, data)
        .then(response => {
          // commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    getEmbedCode({ commit }, video_url) {
      return axiosIns
          .post(`${ROOT_URL}/embedCode`, { video_url })
          .then(response => {
            commit('SET_VIDEO_EMBED_SAVE', response.data)
            return response.data
          })
          .catch(error => console.error(error))
    },
  },
}
